import React, { Component } from 'react'
import actions from 'redux/actions'
import PropTypes from 'prop-types'
import { mixpanel, constants } from 'common/helpers'
import cx from 'classnames'
import { intlMessageShape } from 'sb-react-intl'

import Center from 'components/layout/Center/Center'
import Overlay from 'components/layout/Overlay/Overlay'
import CloseIcon from 'components/ui/CloseIcon/CloseIcon'
import Header from 'components/_new/layout/Header/Header'
import Headline from 'components/_new/typography/deprecated/Headline/Headline'
import { WidthContainer } from 'components/_new/layout/widthContainer'

import s from './Modal.scss'


class Modal extends Component {

  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    id: PropTypes.string,
    name: PropTypes.string.isRequired,
    data: PropTypes.object,
    title: PropTypes.shape(intlMessageShape),
    subTitle: PropTypes.shape(intlMessageShape),
    fullWidth: PropTypes.bool,
    disableClose: PropTypes.bool,
    showCloseButton: PropTypes.bool,
    disableCloseOverlay: PropTypes.bool,
    onClose: PropTypes.func,
    onClick: PropTypes.func,
  }

  static defaultProps = {
    data: {},
    showCloseButton: true,
    fullWidth: false,
    disableClose: false,
    disableCloseOverlay: false,
  }

  componentWillMount() {
    this.resolveEvents()
  }

  handleMount = (el) => {
    if (el) {
      setTimeout(() => {
        el.classList.add(s.mounted)
      }, 0)
    }
  }

  resolveEvents() {
    const { data: { mixpanelEvent } } = this.props

    if (mixpanelEvent) {
      const { name, ...rest } = mixpanelEvent

      mixpanel.track(name, rest)
    }
  }

  close = () => {
    const { name, data, onClose } = this.props

    actions.models.modals.close(name)

    if (typeof onClose === 'function') {
      onClose()
    }

    if (typeof data.onClose === 'function') {
      data.onClose()
    }
  }

  handleClickOverlay = () => {
    const { disableClose, disableCloseOverlay } = this.props

    if (!disableClose && !disableCloseOverlay) {
      this.close()
    }
  }

  handleClickCloseButton = () => {
    const { disableClose } = this.props

    if (!disableClose) {
      this.close()
    }
  }

  render() {
    const {
      name, children, className, id, title, subTitle, fullWidth, showCloseButton, disableClose,
      onClick,
    } = this.props

    const modalContainerClassName = cx(s.modalContainer, {
      [s.fullWidth]: fullWidth,
    })

    const modalClassName = cx(s.modal, className)

    return (
      <Overlay onClick={this.handleClickOverlay} dataToggleOff={name}>
        <Center scrollable>
          <div
            className={modalContainerClassName}
            ref={this.handleMount}
            onClick={(event) => event.stopPropagation()}
          >
            <WidthContainer
              className={modalClassName}
              id={id}
              data-testid={constants.testIds.modal.root}
              onClick={onClick}
            >
              <Header className={s.header}>
                {
                  showCloseButton && !disableClose && (
                    <CloseIcon
                      className={s.closeButton}
                      onClick={this.handleClickCloseButton}
                      dataTestId={constants.testIds.modal.closeIcon}
                    />
                  )
                }
              </Header>
              <Headline title={title} subTitle={subTitle} size="lg" />
              <div className={s.content}>
                {children}
              </div>
            </WidthContainer>
          </div>
        </Center>
      </Overlay>
    )
  }
}


export default Modal
